module.exports = __webpack_public_path__ + "img/IMG_1039_L_BlackMatted_MockedUp.054ffd88.jpg";